// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1yfQw{height:25px}.gbeLR{font-size:15px}._3_W4V{margin:25px}", ""]);
// Exports
exports.locals = {
	"space": "_1yfQw",
	"badge": "gbeLR",
	"features": "_3_W4V"
};
module.exports = exports;
